export enum ClaimType {
  UserType = "UserType",
  family_name = "family_name",
  Name = "name",
  AccessTo = "AccessTo",
  UserInfoId = "UserInfoId",
  CountyGuildRoomManagerLocationId = "CountyGuildRoomManager.LocationId",
  ProvinceGuildRoomManagerLocationId = "ProvinceGuildRoomManager.LocationId",
  Test2LocationId = "Test2.LocationId",
  Test1LocationId = "Test1.LocationId",
  MainLocationGuildRoomManagerLocationId = "MainLocationGuildRoomManager.LocationId",
}

export enum ClaimValue {
  Value1 = "1",
  Value17 = "17",
  Lvl1 = "lvl1",
  Value107 = "107",
  Value12 = "12",
  Value10 = "10",
  Value9 = "9",
  Value2 = "2",
}
